import { convertToSchedulingSelectionItem } from 'owa-day-grid-core-utilities';
import { KnownItemTypes } from 'owa-calendar-surface-dategrid';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { addMinutes, isBefore } from 'owa-datetime';
import type { DateRange } from 'owa-datetime-utils';

// Free busy returns availability in intervals of 15 minutes
const freeBusySlotSizeInMinutes = 15;

export default function getFreeBusySurfaceItems(dateRange: DateRange): CalendarEvent[] {
    let result: CalendarEvent[] = [];

    for (
        let start = dateRange.start, end = addMinutes(start, freeBusySlotSizeInMinutes);
        isBefore(start, dateRange.end);
        start = end, end = addMinutes(end, freeBusySlotSizeInMinutes)
    ) {
        result.push(
            convertToSchedulingSelectionItem(
                {
                    Start: start,
                    End: end,
                    IsAllDayEvent: false,
                },
                KnownItemTypes.attendeesItems
            )
        );
    }

    return result;
}
